module.exports = __webpack_public_path__ + "img/vnpay.92494869.png";